export const frontendSkills = [
  { type: "Html", level: 90 },
  { type: "Css", level: 85 },
  { type: "JavaScript", level: 80 },
  { type: "React.js", level: 60 },
  { type: "Gatsby.js", level: 50 },
  { type: "Bootstrap", level: 75 },
  { type: "Sass", level: 25 },
  { type: "Jest", level: 30 },
  { type: "jQuery", level: 35 },
]

export const frontendSkillsColor = {
  bar: "#3498db",
  title: {
    text: "#fff",
    background: "#2980b9",
  },
}

export const backendSkills = [
  { type: "Node.Js", level: 60 },
  { type: "Php", level: 40 },
  { type: "Express.Js", level: 45 },
]

export const backendSkillsColor = {
  bar: "#00bd3f",
  title: {
    text: "#fff",
    background: "#009331",
  },
}

export const dbSkills = [
  { type: "MongoDB", level: 60 },
  { type: "MySQL", level: 35 },
  { type: "Mongoose", level: 40 },
]

export const dbSkillsColor = {
  bar: "#f09c00",
  title: {
    text: "#fff",
    background: "#b46900",
  },
}
